import styled from 'styled-components';
import Colors from 'library/constants/colors';
import {
  IconBase,
  ActionIconListItemBig,
  SlickArrowStyles,
  ActionIconListItemBigHorizontal,
} from 'library/styles/icon';
import { Container as Color } from 'library/components/color/styles';
import { ButtonMid, Header4 } from 'library/styles/text';
import {
  ShadowBig, ShadowHarsh, ShadowSlight, TransitionConfig,
} from 'library/constants/styles-config';
import { ButtonBaseStyles } from '../../styles/button';

export const Icon = styled(IconBase)`
  color: ${Colors.violet};
`;

export const ItemAction = styled(ActionIconListItemBig)``;

export const StyledForm = styled.form`
  width: 100%;
`;

export const ItemActionHorizontal = styled(ActionIconListItemBigHorizontal)`
  white-space: nowrap;

  ${({ disabled }) => disabled && `
    background-color: ${Colors.shade05};
    opacity: 0.5;
    
    i {
        cursor: not-allowed;
    }
  `}
`;

export const Container = styled.div.attrs(({ top }) => ({
  style: {
    top,
    height: `calc(100vh - ${top}px)`,
  },
}))`
  position: fixed;
  right: 0;
  bottom: 0;
  width: 540px;
  overflow: scroll;
  z-index: 10;
  border-left: 2px solid ${Colors.shade06};
  box-sizing: border-box;
  background-color: ${Colors.shade08};
  box-shadow: ${ShadowBig};

  /* Works on Firefox */
  scrollbar-width: thin;
  scrollbar-color: transparent ${Colors.shade02};

  &:hover { scrollbar-color: transparent; }

  /* Works on Chrome, Edge, and Safari */
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 0 5px 5px 0;
  }

  &::-webkit-scrollbar-thumb {
    background: ${Colors.shade02};
    border: 1px solid ${Colors.shade02};
    border-radius: 25px;

    &:hover { background: ${Colors.shade02}; }
  }

  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  header {
    display: flex;
    justify-content: space-between;
    padding: 31px 36px 7px 38px;

    ${ItemActionHorizontal} {
      position: relative;
      float: right;
      z-index: 10;
    }
  }

  .slick-slide,
  .slick-slider .slick-track,
  .slick-slider .slick-list
  {
  }

  .slick-list {
    width: 533px;
    padding-top: 24px;
    padding-bottom: 24px;
    overflow-x: hidden;
  }

  .slick-track {
    display: flex;
    justify-content: start;
  }

  .slick-slide {
    display: inline-block;
  }

  .slick-arrow {
    ${SlickArrowStyles};
  }
`;

export const Header = styled(Header4)`
  display: inline-block;
  margin-top: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  //flex-grow: 0;
`;

export const DetailsContainer = styled.div`
  position: relative;
`;

export const Attributes = styled.div`
  max-width: 100%;
`;

export const HeaderContainer = styled.header``;

export const Attribute = styled.div`
  height: 55px;
  line-height: 55px;
  margin: 1px 0 0;
  padding-left: 6px;
  background-color: ${Colors.shade08};
  border-radius: 5px;
  box-shadow: 0 1px 0 0 #EBEEEF;

  span {
    ${Color} {
      margin-right: 2px;
      vertical-align: -7px;

      &:not(:first-child) {
        margin-left: 2px;
      }
    }
  }

  ${Icon} {
    margin-right: 5px;
    vertical-align: -4px;
  }
`;

export const Actions = styled.ul`
  margin-top: 0;
  margin-left: 31px;
  padding-left: 0;
  width: 48px;
  z-index: 5;

  ${ItemActionHorizontal} {
    float: right;
    margin-top: 5px;
    margin-bottom: 5px;
  }
`;

export const FormActions = styled.div`
  display: flex;
  padding: 2px 42px 32px;
`;

export const ButtonFileContainer = styled.div`
`;

export const ButtonFile = styled.label`
  ${ButtonBaseStyles};
  ${ButtonMid};
  margin: -4px 0 32px;
  box-shadow: ${ShadowSlight};
  background-color: ${Colors.shade08};
  transition: background-color ${TransitionConfig}, box-shadow ${TransitionConfig};
  
  &:hover {
    background-color: ${Colors.shade07};
    box-shadow: ${ShadowHarsh};
  }
`;

export const FieldContainer = styled.div`
  //flex-grow: 1;
  width: 100%;
`;

export const InfoContainer = styled.div`
  padding: 0 42px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  width: 100%;
`;
